import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';

import type { RoleType } from './type';

const useGetRoles = () => {
  const { id } = useParams();

  const [rolesList, setRolesList] = useState<RoleType[]>([]);
  const [userRoles, setUserRoles] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const getRolesList = useCallback(async () => {
    setLoading(true);
    try {
      const roles = await api.get('/user/roles');

      const userRoles = await api.get(`/user/${id}/roles`);

      setRolesList(roles.data);
      setUserRoles(userRoles.data.roles);
    } catch (error) {
      toast.error('Erro ao carregar as permissões. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to fetch user roles'), {
        error,
        userId: id,
      });
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    getRolesList();
  }, [getRolesList]);

  return {
    rolesList,
    userRoles,
    loading,
  };
};

export default useGetRoles;
